export const maxHeightbpSmall = '@media (max-height: 34.312em)'